module.exports = __webpack_public_path__ + "assets/img/store-text-2.d2b132f4.png";